import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

/** Misma familia de iconos que hormigón pedidos (cbb_express): edit_google / figma-x-gray. */
export type CbbTableActionIconVariant = 'edit' | 'void' | 'reactivate';

@Component({
  selector: 'app-cbb-table-action-icon',
  templateUrl: './cbb-table-action-icon.component.html',
  styleUrls: ['./cbb-table-action-icon.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CbbTableActionIconComponent {
  @Input({ required: true }) variant!: CbbTableActionIconVariant;

  /** Texto para title y aria-label (tooltip y lector de pantalla). */
  @Input() label = '';

  @Input() disabled = false;

  /** Si es false, el icono se muestra atenuado y no emite (misma idea que restringirEditar / restringirAnular en cbb_express). */
  @Input() active = true;

  @Output() readonly action = new EventEmitter<void>();

  emitClick(event: Event): void {
    if (this.disabled || !this.active) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    this.action.emit();
  }

  ariaLabel(): string {
    if (this.label.trim()) {
      return this.label;
    }
    if (this.variant === 'edit') return 'Editar';
    if (this.variant === 'reactivate') return 'Reactivar';
    return 'Anular';
  }
}
